import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/authSlice";
import accountReducer from "./slice/accountSlice";
import contentReducer from "./slice/contentSlice";
import subscriptionReducer from "./slice/subscriptionSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    account: accountReducer,
    content: contentReducer,
    subscription: subscriptionReducer,
  },
});

export default store;
